import { DECIMAL_RE } from '../regexes';

export function validateInteger(value) {
    const type = typeof value;
    if (type !== 'number' && type !== 'string') {
        return false;
    }

    const parsed =
        type === 'string' && DECIMAL_RE.test(value)
            ? parseInt(value, 10)
            : value;

    return isFinite(parsed) && parsed === Math.floor(parsed);
}
